<template>
  <v-row>
    <v-col>
      <v-textarea
        no-resize
        outlined
        label="Beskrivning"
        v-model="model"
        placeholder=" "
        :rules="[required]"
        hint="Obligatorisk"
        persistent-hint
        :disabled="readonly"
      />
    </v-col>
  </v-row>
</template>

<script>
import { required } from '@/common/validationRules'
import { sync } from 'vuex-pathify'

export default {
  name: 'OdocDescriptionInput',

  props: {
    readonly: Boolean
  },

  data() {
    return { required }
  },

  computed: {
    model: sync('odoc/model@description')
  }
}
</script>
